import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Breadcrumb, Button, Icon, Menu, Popup, Table } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import MyInvoiceSearchForm from './MyInvoiceSearchForm';

const MyInvoicesPage = ({ invoices, user, getInvoices, updateInvoice }) => {
  const [myInvoices, setMyInvoices] = useState([]);

  useEffect(() => {
    getInvoices();
  }, []);

  useEffect(() => {
    const temp = invoices.filter(invoice => invoice.contributorId === user.id);
    setMyInvoices(temp);
  }, [invoices]);

  const getPage = () => (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>Invoices</Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>My Invoices</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless>
        <Menu.Item header>
          <Icon name="user circle outline" />
          My Invoices
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Button as="a" href="/invoice" content="Add invoice" icon="plus" positive />
          </Menu.Item>
          <Menu.Item header>
            <Popup
              className="adslot-search-popup"
              wide
              flowing
              position="bottom left"
              trigger={<Button content="Filter" fluid icon="filter" />}
              on="click"
            >
              <MyInvoiceSearchForm />
            </Popup>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Table size="small" compact="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Contributor</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>Assigned By</Table.HeaderCell>
            <Table.HeaderCell>Completed</Table.HeaderCell>
            <Table.HeaderCell>Amount</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>City</Table.HeaderCell>
            <Table.HeaderCell>Approved</Table.HeaderCell>
            <Table.HeaderCell>Comments from Editor</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {myInvoices
            .filter(i => !i.isDeleted)
            .map((invoice, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>{invoice?.contributor?.name}</Table.Cell>
                <Table.Cell>{invoice.description}</Table.Cell>
                <Table.Cell>{invoice?.editor?.name}</Table.Cell>
                <Table.Cell>{invoice.date}</Table.Cell>
                <Table.Cell>{invoice.amount}</Table.Cell>
                <Table.Cell>{invoice.type}</Table.Cell>
                <Table.Cell>{invoice?.site?.name}</Table.Cell>
                <Table.Cell>
                  <input type="checkbox" checked={invoice.isApproved} disabled />
                </Table.Cell>
                <Table.Cell>{invoice.editorComments}</Table.Cell>
                <Table.Cell>
                  <Popup
                    trigger={<Button negative icon="trash" basic size="tiny" />}
                    content={
                      <Button
                        color="green"
                        content="Are you sure?"
                        onClick={() => updateInvoice({ ...invoice, isDeleted: true })}
                      />
                    }
                    on="click"
                    position="bottom left"
                  />
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </PageContainer>
  );

  return <>{invoices && getPage()}</>;
};

const mapStateToProps = state => ({
  invoices: selectors.getAllInvoices(state),
  user: selectors.getUser(state),
});

const mapDispatchToProps = dispatch => ({
  getInvoices: bindActionCreators(actions.invoices.getInvoices, dispatch),
  updateInvoice: bindActionCreators(actions.invoices.updateInvoice, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyInvoicesPage);
